export const EXECUTIVE_BRIEFS_CANONICAL_PATH = '/executive-summaries/briefs';

export const EXECUTIVE_BRIEFS_TABS = [
  'strategy',
  'finance',
  'operations',
  'org',
  'portfolio',
] as const;

export type ExecutiveBriefsTab = (typeof EXECUTIVE_BRIEFS_TABS)[number];

export const EXECUTIVE_BRIEFS_DEFAULT_TAB: ExecutiveBriefsTab = 'operations';

export type ExecutiveBriefsQueryState = {
  tab?: string | null;
  strategyId?: string | null;
  packVersionId?: string | null;
  runId?: string | null;
  scopeRootNodeId?: string | null;
  basePath?: string;
};

export type ExecutiveBriefsSearchParams = Record<
  string,
  string | string[] | undefined
>;

function readText(value: string | null | undefined): string | null {
  const trimmed = String(value ?? '').trim();
  return trimmed || null;
}

export function readFirstSearchParam(
  value: string | string[] | undefined,
): string | null {
  if (!value) return null;
  if (Array.isArray(value)) return readText(value[0]);
  return readText(value);
}

export function normalizeExecutiveBriefsTab(
  value: string | null | undefined,
): ExecutiveBriefsTab {
  const trimmed = readText(value);
  if (!trimmed) return EXECUTIVE_BRIEFS_DEFAULT_TAB;
  return EXECUTIVE_BRIEFS_TABS.includes(trimmed as ExecutiveBriefsTab)
    ? (trimmed as ExecutiveBriefsTab)
    : EXECUTIVE_BRIEFS_DEFAULT_TAB;
}

export function buildExecutiveBriefsHref({
  tab,
  strategyId,
  packVersionId,
  runId,
  scopeRootNodeId,
  basePath = EXECUTIVE_BRIEFS_CANONICAL_PATH,
}: ExecutiveBriefsQueryState): string {
  const qs = new URLSearchParams();
  qs.set('tab', normalizeExecutiveBriefsTab(tab));

  const normalizedStrategyId = readText(strategyId);
  const normalizedPackVersionId = readText(packVersionId);
  const normalizedRunId = readText(runId);
  const normalizedScopeRootNodeId = readText(scopeRootNodeId);

  if (normalizedStrategyId) qs.set('strategyId', normalizedStrategyId);
  if (normalizedPackVersionId) qs.set('packVersionId', normalizedPackVersionId);
  if (normalizedRunId) qs.set('runId', normalizedRunId);
  if (normalizedScopeRootNodeId) qs.set('scopeRootNodeId', normalizedScopeRootNodeId);

  return `${basePath}?${qs.toString()}`;
}
